import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Paper,
  Typography,
  Box,
  Divider,
  Button,
  ListItemIcon,
  Fab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Tooltip,
  CircularProgress,
  Chip,
  Breadcrumbs,
  Link,
  useTheme,
  // ---- MODIFICACIÓN: Importar Snackbar y Alert ----
  Snackbar,
  Alert,
} from "@mui/material";
import { teal, green } from "@mui/material/colors";

// Iconos
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import ArticleIcon from "@mui/icons-material/Article";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import axios from "axios";
//Componentes Importados
import Restricted from "components/Restricted";
import { QuestionMark } from "@mui/icons-material";

const QuestionLista = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const nav = useNavigate();
  const pool = location.state?.pool;

  const theme = useTheme();

  const [items, setItems] = React.useState([]);
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  const handleLinkHome = (event, message) => {
    if (message === "home") nav("/inicio");
  };
  const handleLinkGestion = (event, message) => {
    if (message === "gestion") nav("/gestionhumana");
  };
  const handleLinkPools = (event, message) => {
    if (message === "pool") nav("/poolLista");
  };

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const [openFormModal, setOpenFormModal] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [question, setQuestion] = useState("");
  const [answers, setAnswers] = useState([
    { text: "", isCorrect: false },
    { text: "", isCorrect: false },
    { text: "", isCorrect: false },
    { text: "", isCorrect: false },
  ]);
  const [difficulty, setDifficulty] = useState("");
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  // ---- MODIFICACIÓN: Estados para el Snackbar ----
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
  const fetchQuestions = async () => {
    if (!pool) return;
    try {
      const { data } = await axios.get(`/pools/${pool.id}/preguntas`);
      // data: [{ id_pregunta, enunciado_pregunta, dificultad, ... }, ...]
      console.log(data,"Respuestas")
      const mapped = data.map((p) => ({
        id: p.id_pregunta,
        question: p.enunciado_pregunta,
        difficulty:
          p.dificultad === 1
            ? "Basico"
            : p.dificultad === 2
            ? "Intermedio"
            : p.dificultad === 3
            ? "Avanzado"
            : "Experto",
        // por ahora sin respuestas; si quieres, luego traemos también respuestas
        answers: p.respuestas,
      }));
      
      setQuestions(mapped);
    } catch (error) {
      console.error("Error cargando preguntas del pool:", error);
      showSnackbar("Error cargando preguntas del pool.", "error");
    } finally {
      setLoading(false);
    }
  };

  fetchQuestions();
}, [pool]);

  const openMenu = Boolean(anchorEl);
  const handleBack = () => navigate("/poolLista");
const mapDifficultyToNumber = (dif) => {
  switch (dif) {
    case "Basico":
      return 1;
    case "Intermedio":
      return 2;
    case "Avanzado":
      return 3;
    case "Experto":
      return 4;
    default:
      return 1;
  }
};
  // ---- MODIFICACIÓN: Funciones para manejar el Snackbar ----
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const resetForm = () => {
    setQuestion("");
    setAnswers([
      { text: "", isCorrect: false },
      { text: "", isCorrect: false },
      { text: "", isCorrect: false },
      { text: "", isCorrect: false },
    ]);
    setDifficulty("");
    setErrors({});
    setEditingQuestion(null);
  };

  const handleCloseFormModal = () => {
    setOpenFormModal(false);
    setTimeout(resetForm, 300);
  };

  const handleOpenCreateModal = () => {
    resetForm();
    setOpenFormModal(true);
  };

  const handleOpenEditModal = () => {
    if (selectedQuestion) {
      setEditingQuestion(selectedQuestion);
      setQuestion(selectedQuestion.question || "");
      setAnswers(
        selectedQuestion.answers || [
          { text: "", isCorrect: false },
          { text: "", isCorrect: false },
          { text: "", isCorrect: false },
          { text: "", isCorrect: false },
        ]
      );
      setDifficulty(selectedQuestion.difficulty || "");
      setErrors({});
      setOpenFormModal(true);
    }
    handleMenuClose();
  };

  const formatInputText = (text) => {
    if (!text) return "";
    return text
      .trimStart()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleQuestionChange = (event) =>
    setQuestion(formatInputText(event.target.value));
  const handleAnswerChange = (index, event) => {
    const newAnswers = [...answers];
    newAnswers[index].text = formatInputText(event.target.value);
    setAnswers(newAnswers);
  };
  const handleCorrectAnswerChange = (selectedIndex, event) => {
    setAnswers(
      answers.map((answer, index) => ({
        ...answer,
        isCorrect: index === selectedIndex ? event.target.checked : false,
      }))
    );
  };
  const handleDifficultyChange = (event) => setDifficulty(event.target.value);

 const validateAndSubmit = async (event) => {
  event.preventDefault();

  const newErrors = {};
  if (!question.trim()) newErrors.question = "Campo obligatorio";
  answers.forEach((answer, index) => {
    if (!answer.text.trim())
      newErrors[`answer_${index}`] = "Campo obligatorio";
  });
  if (
    answers.every((a) => a.text.trim()) &&
    !answers.some((a) => a.isCorrect)
  ) {
    newErrors.correctAnswer = "Debes seleccionar una respuesta correcta";
  }
  if (!difficulty) newErrors.difficulty = "Campo obligatorio";

  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) return;

  setIsSaving(true);

  try {
    const payload = {
      id_categoria: pool.id_categoria,          // categoría del pool
      id_pool: pool.id,                        // asignar la pregunta a este pool
      dificultad: mapDifficultyToNumber(difficulty),
      enunciado_pregunta: question.trim(),
      respuestas: answers.map((a) => ({
        texto_respuesta: a.text.trim(),
        es_correcta: a.isCorrect,
      })),
    };

    if (editingQuestion) {
      // aquí, cuando quieras, podrás integrar PUT /preguntas/:id
      // por ahora, mantenemos edición solo en memoria para no romper nada
      setQuestions((qs) =>
        qs.map((q) =>
          q.id === editingQuestion.id
            ? { ...q, question: payload.enunciado_pregunta, difficulty, answers }
            : q
        )
      );
      showSnackbar("Pregunta editada con éxito.", "success");
    } else {
      const { data } = await axios.post("/preguntasExamen", payload);
      // data: la pregunta creada (id_pregunta, enunciado_pregunta, dificultad numérica, etc.)
      setQuestions((qs) => [
        ...qs,
        {
          id: data.id_pregunta,
          question: data.enunciado_pregunta,
          difficulty,
          answers,
        },
      ]);
      showSnackbar("Pregunta creada con éxito.", "success");
    }

    handleCloseFormModal();
  } catch (error) {
    console.error("Error guardando pregunta:", error);
    showSnackbar("Error guardando la pregunta en el servidor.", "error");
  } finally {
    setIsSaving(false);
  }
};


  const correctAnswerIndex = answers.findIndex((a) => a.isCorrect);
  const allAnswersFilled = answers.every((answer) => answer.text.trim() !== "");

  const handleMenuOpen = (event, question) => {
    setAnchorEl(event.currentTarget);
    setSelectedQuestion(question);
    console.log(questions)
  };
  const handleMenuClose = () => setAnchorEl(null);

 const handleDelete = async () => {
  if (!selectedQuestion) return;

  try {
    await axios.delete(`/preguntas/${selectedQuestion.id}`);
    setQuestions((currentQuestions) =>
      currentQuestions.filter((q) => q.id !== selectedQuestion.id)
    );
    showSnackbar("Pregunta eliminada con éxito.", "success");
  } catch (error) {
    console.error("Error eliminando pregunta:", error);
    showSnackbar("Error eliminando la pregunta en el servidor.", "error");
  }

  handleMenuClose();
};


  const handleOpenDetailsModal = () => {
    setOpenDetailsModal(true);
    handleMenuClose();
  };
  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
  };

  if (!pool) {
    return (
      <Container maxWidth="lg" sx={{ my: 4, textAlign: "center" }}>
        <Typography variant="h5">No se ha seleccionado ningún pool.</Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ mt: 2 }}
        >
          Volver a la Lista de Pools
        </Button>
      </Container>
    );
  }

  return (
    <div className="exclude">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Box m="1.5rem 2.5rem">
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/gestionhumana"
                  onClick={(event) => handleLinkGestion(event, "gestion")}
                >
                  <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión Humana
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/poolLista"
                  onClick={(event) => handleLinkPools(event, "pool")}
                >
                  <QuizIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestion de Pools
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <HelpOutlineIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Preguntas
                </Typography>
              </Breadcrumbs>
            </Box>
            <Container maxWidth="xl" sx={{ my: 4, px: "0 !important" }}>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ mt: 8 }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbarSeverity}
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
              <Box sx={{ my: 4, pb: { xs: 10, sm: 0 } }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  mb={3}
                >
                  <Box>
                    <Typography variant="h3" component="h1" gutterBottom>
                      <b>Preguntas de:</b> <span>{pool.name}</span>
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenCreateModal}
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      bgcolor: teal[500],
                      "&:hover": { bgcolor: teal[700] },
                    }}
                  >
                    Nueva Pregunta
                  </Button>
                </Box>

                {loading ? (
  <Box sx={{ py: 8, textAlign: "center" }}>
    <CircularProgress />
  </Box>
):questions.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 10,
                      color: "text.secondary",
                    }}
                  >
                    <PlaylistAddIcon sx={{ fontSize: "6rem", mb: 2 }} />
                    <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                      Aún no hay preguntas
                    </Typography>
                  </Box>
                ) : (
                  <React.Fragment>
                    <Paper
                      elevation={3}
                      sx={{
                        borderRadius: 4,
                        bgcolor: theme.palette.background.alt,
                      }}
                    >
                      <List sx={{ p: 0 }}>
                        {questions.map((q, index) => (
                          <React.Fragment key={q.id}>
                            <ListItem
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  onClick={(e) => handleMenuOpen(e, q)}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              }
                              sx={{ py: 2 }}
                            >
                              <ListItemIcon>
                                <HelpOutlineIcon
                                  color="action"
                                  sx={{
                                    fontSize: { xs: "2rem", sm: "2.5rem" },
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={q.question}
                                secondary={`Dificultad: ${q.difficulty}`}
                                primaryTypographyProps={{
                                  fontWeight: "bold",
                                  sx: {
                                    fontSize: { xs: "1rem", sm: "1.03rem" },
                                  },
                                }}
                                secondaryTypographyProps={{
                                  sx: {
                                    fontSize: { xs: "0.875rem", sm: "0.95rem" },
                                  },
                                }}
                              />
                            </ListItem>
                            {index < questions.length - 1 && (
                              <Divider variant="inset" component="li" />
                            )}
                          </React.Fragment>
                        ))}
                      </List>
                    </Paper>
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                      <Typography
                        variant="h6"
                        component="p"
                        sx={{ color: "text.secondary", fontWeight: "bold" }}
                      >
                        Total de Preguntas: {questions.length}
                      </Typography>
                    </Box>
                  </React.Fragment>
                )}

                <Menu
                  id="question-menu"
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleOpenDetailsModal}>
                    <ListItemIcon>
                      <ArticleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Detalles</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleOpenEditModal}>
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <ListItemText>Eliminar</ListItemText>
                  </MenuItem>
                </Menu>
              </Box>

              <Fab
                aria-label="crear nueva pregunta"
                onClick={handleOpenCreateModal}
                sx={{
                  display: { xs: "flex", sm: "none" },
                  position: "fixed",
                  bottom: 24,
                  right: 24,
                  bgcolor: teal[500],
                  color: "white",
                  "&:hover": { bgcolor: teal[700] },
                  width: 72,
                  height: 72,
                }}
              >
                <AddIcon sx={{ fontSize: "2.5rem" }} />
              </Fab>

              <Dialog
                open={openFormModal}
                onClose={handleCloseFormModal}
                fullWidth
                maxWidth="md"
                PaperProps={{
                  sx: {
                    borderRadius: 4,
                    bgcolor: theme.palette.background.alt,
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: { xs: "1.15rem", sm: "1.5rem" },
                  }}
                >
                  {editingQuestion ? "Editar Pregunta" : "Crear Nueva Pregunta"}
                </DialogTitle>
                <form onSubmit={validateAndSubmit} noValidate>
                  <DialogContent sx={{ pt: "10px !important" }}>
                    <Box mb={3} mt={1}>
                      <TextField
                        fullWidth
                        autoFocus
                        label="Enunciado de la Pregunta"
                        variant="outlined"
                        value={question}
                        onChange={handleQuestionChange}
                        required
                        error={!!errors.question}
                        helperText={errors.question || ""}
                      />
                    </Box>
                    <Typography variant="h6" component="h3" gutterBottom>
                      <b>Respuestas</b>
                    </Typography>
                    <FormGroup>
                      {answers.map((answer, index) => (
                        <Box
                          key={index}
                          display="flex"
                          alignItems="center"
                          mb={2}
                        >
                          <TextField
                            fullWidth
                            label={`Respuesta ${index + 1}`}
                            variant="outlined"
                            value={answer.text}
                            onChange={(e) => handleAnswerChange(index, e)}
                            required
                            sx={{ mr: 2 }}
                            error={!!errors[`answer_${index}`]}
                            helperText={errors[`answer_${index}`] || ""}
                          />
                          {(correctAnswerIndex === index ||
                            (correctAnswerIndex === -1 &&
                              allAnswersFilled)) && (
                            <Tooltip
                              title="Marcar como respuesta correcta"
                              placement="right"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="success"
                                    checked={answer.isCorrect}
                                    onChange={(e) =>
                                      handleCorrectAnswerChange(index, e)
                                    }
                                  />
                                }
                                label={answer.isCorrect ? "Correcta" : ""}
                                sx={{
                                  ...(answer.isCorrect && {
                                    color: "success.main",
                                  }),
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                      ))}
                      {errors.correctAnswer && (
                        <FormHelperText error sx={{ mt: -1, mb: 2 }}>
                          {errors.correctAnswer}
                        </FormHelperText>
                      )}
                    </FormGroup>
                    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        required
                        error={!!errors.difficulty}
                      >
                        <InputLabel>Dificultad</InputLabel>
                        <Select
                          label="Dificultad"
                          value={difficulty}
                          onChange={handleDifficultyChange}
                        >
                          <MenuItem value="Basico">Básico</MenuItem>
                          <MenuItem value="Intermedio">Intermedio</MenuItem>
                          <MenuItem value="Avanzado">Avanzado</MenuItem>
                          <MenuItem value="Experto">Experto</MenuItem>
                        </Select>
                        <FormHelperText>
                          {errors.difficulty || ""}
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  </DialogContent>
                  <Divider sx={{ my: 2 }} />
                  <DialogActions sx={{ p: "16px 24px" }}>
                    <Button
                      onClick={handleCloseFormModal}
                      variant="contained"
                      color="error"
                      size="large"
                      disabled={isSaving}
                      sx={{ mr: 2 }}
                    >
                      Cancelar
                    </Button>
                    <Box sx={{ position: "relative" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={isSaving}
                        sx={{
                          backgroundColor: "teal",
                          "&:hover": { backgroundColor: "#00695c" },
                        }}
                      >
                        {isSaving ? "Guardando..." : "Guardar"}
                      </Button>
                      {isSaving && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "teal",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </Box>
                  </DialogActions>
                </form>
              </Dialog>

              <Dialog
                open={openDetailsModal}
                onClose={handleCloseDetailsModal}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                  sx: {
                    borderRadius: 4,
                    bgcolor: theme.palette.background.alt,
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: { xs: "1.15rem", sm: "1.5rem" },
                  }}
                >
                  Detalles de la Pregunta
                </DialogTitle>
                <Divider sx={{ width: "95%", mx: "auto" }} />
                <DialogContent>
                  {selectedQuestion && (
                    <Box>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          fontSize: "1.05rem",
                          mt: 2,
                          textAlign: "center",
                        }}
                      >
                        {selectedQuestion.question}
                      </Typography>
                      <Box display="flex" alignItems="center" sx={{ mt: 3 }}>
                        <Divider sx={{ flexGrow: 1, mr: 1.5 }} />
                        <Chip label="DIFICULTAD" size="small" />
                        <Divider sx={{ flexGrow: 1, ml: 1.5 }} />
                      </Box>
                      <Typography variant="body1" gutterBottom sx={{ mt: 1 }}>
                        {selectedQuestion.difficulty}
                      </Typography>
                      <Box display="flex" alignItems="center" sx={{ mt: 3 }}>
                        <Divider sx={{ flexGrow: 1, mr: 1.5 }} />
                        <Chip label="RESPUESTAS" size="small" />
                        <Divider sx={{ flexGrow: 1, ml: 1.5 }} />
                      </Box>
                      <List>
                        {selectedQuestion.answers.map((answer, index) => (
                          <ListItem
                            key={index}
                            sx={{
                              p: 1.5,
                              ...(answer.es_correcta && {
                                bgcolor: green[50],
                                borderRadius: 2,
                                my: 0.5,
                              }),
                            }}
                          >
                            <ListItemIcon sx={{ minWidth: "auto", mr: 1.5 }}>
                              <FiberManualRecordIcon
                                sx={{
                                  fontSize: "0.6rem",
                                  color: "text.secondary",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={answer.texto_respuesta}
                              primaryTypographyProps={{
                                ...(answer.es_correcta && { fontWeight: "bold" }),
                              }}
                            />
                            {answer.es_correcta && (
                              <Chip
                                label="Correcta"
                                color="success"
                                size="medium"
                                sx={{ ml: 2 }}
                              />
                            )}
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  )}
                </DialogContent>
                <Divider sx={{ width: "95%", mx: "auto" }} />
                <DialogActions sx={{ p: "16px 24px" }}>
                  <Button
                    onClick={handleCloseDetailsModal}
                    variant="contained"
                    color="error"
                    size="large"
                  >
                    Cerrar
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          </Box>
        </>
      ) : (
        <Box m="1.5rem 2.5rem">
          <Restricted />
        </Box>
      )}
    </div>
  );
};

export default QuestionLista;
